var map = {
	"./ar/media/MediaPage.vue": [
		3917,
		917
	],
	"./en/media/MediaPage.vue": [
		9984,
		984
	],
	"./fa/media/MediaPage.vue": [
		6236,
		236
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 4650;
module.exports = webpackAsyncContext;